import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';

import * as adminActions from '../actions/admin.action';
import {
  switchMap,
  map,
  catchError,
  tap,
  groupBy,
  mergeMap,
  reduce,
  toArray,
  concatMap
} from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { from } from 'rxjs/observable/from';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { BookingService } from '../../booking/services/booking.service';

import * as R from 'ramda';

@Injectable()
export class AdminEffect {
  constructor(
    private actions$: Actions,
    private db: AngularFirestore,
    private bookingService: BookingService,
    private firebaseAuth: AngularFireAuth
  ) {}
  bookings = [];
  @Effect({ dispatch: false })
  getAllBookings$ = this.actions$.ofType(adminActions.GET_ALL_BOOKINGS).pipe(
    switchMap((action: adminActions.GetAllBookings) => {
      return this.bookingService.getAllBookings();
    })
  );

  @Effect()
  bookingByGroupASession$ = this.actions$
    .ofType(adminActions.GET_ALL_BOOKINGS_SUCCESS)
    .pipe(
      map((action: adminActions.GetAllBookingsSuccess) => {
        const bookings: any[] = action.payload;
        const keyPair = R.pipe(R.groupBy((b: any) => b.groupASession))(
          bookings
        );
        const counts = Object.keys(keyPair).map(key => ({
          name: key,
          value: keyPair[key].length
        }));

        // console.log(counts);
        return { counts };
      }),
      map(obj => new adminActions.BookingsByGroupASessionCount(obj))
    );

  @Effect()
  bookingByGroupBSession$ = this.actions$
    .ofType(adminActions.GET_ALL_BOOKINGS_SUCCESS)
    .pipe(
      map((action: adminActions.GetAllBookingsSuccess) => {
        const bookings: any[] = action.payload;
        const keyPair = R.pipe(R.groupBy((b: any) => b.groupBSession))(
          bookings
        );
        const counts = Object.keys(keyPair).map(key => ({
          name: key,
          value: keyPair[key].length
        }));

        return { counts };
      }),
      map(obj => new adminActions.BookingsByGroupBSessionCount(obj))
    );

  // @Effect()
  // bookingByGroupASession$ = this.actions$
  //   .ofType(adminActions.GET_ALL_BOOKINGS_SUCCESS)
  //   .pipe(
  //     switchMap((action: adminActions.GetAllBookingsSuccess) => {
  //       return from(action.payload).pipe(
  //         groupBy((booking: any) => booking.groupASession),
  //         mergeMap(group$ =>
  //           group$.pipe(reduce((acc, cur) => [...acc, cur], []))
  //         ),
  //         toArray()
  //       );
  //     }),
  //     map(vals => {
  //       const counts = [];
  //       vals.forEach(arr => {
  //         counts.push({ name: arr[0].groupASession, value: arr.length });
  //       });
  //       return { counts };
  //     }),
  //     map(obj => new adminActions.BookingsByGroupASessionCount(obj))
  //   );

  // @Effect()
  // bookingByGroupBSession$ = this.actions$
  //   .ofType(adminActions.GET_ALL_BOOKINGS_SUCCESS)
  //   .pipe(
  //     switchMap((action: adminActions.GetAllBookingsSuccess) => {
  //       return from(action.payload).pipe(
  //         groupBy((booking: any) => booking.groupBSession),
  //         mergeMap(group$ =>
  //           group$.pipe(reduce((acc, cur) => [...acc, cur], []))
  //         ),
  //         toArray()
  //       );
  //     }),
  //     map(vals => {
  //       const counts = [];
  //       vals.forEach(arr => {
  //         counts.push({ name: arr[0].groupBSession, value: arr.length });
  //       });
  //       return { counts };
  //     }),
  //     map(obj => new adminActions.BookingsByGroupBSessionCount(obj))
  //   );

  // @Effect()
  // bookingByCountry$ = this.actions$
  //   .ofType(adminActions.GET_ALL_BOOKINGS_SUCCESS)
  //   .pipe(
  //     switchMap((action: adminActions.GetAllBookingsSuccess) => {
  //       return from(action.payload).pipe(
  //         groupBy((booking: any) => booking.country),
  //         mergeMap(group$ =>
  //           group$.pipe(reduce((acc, cur) => [...acc, cur], []))
  //         ),
  //         toArray()
  //       );
  //     }),
  //     map(vals => {
  //       const counts = [];
  //       vals.forEach(arr => {
  //         counts.push({ name: arr[0].country, value: arr.length });
  //       });
  //       return { counts };
  //     }),
  //     map(obj => new adminActions.BookingsByCountry(obj))
  //   );

  // @Effect()
  // bookingByGender$ = this.actions$
  //   .ofType(adminActions.GET_ALL_BOOKINGS_SUCCESS)
  //   .pipe(
  //     switchMap((action: adminActions.GetAllBookingsSuccess) => {
  //       return from(action.payload).pipe(
  //         groupBy((booking: any) => booking.gender),
  //         mergeMap(group$ =>
  //           group$.pipe(reduce((acc, cur) => [...acc, cur], []))
  //         ),
  //         toArray()
  //       );
  //     }),
  //     map(vals => {
  //       const counts = [];
  //       vals.forEach(arr => {
  //         counts.push({ name: arr[0].gender, value: arr.length });
  //       });
  //       return { counts };
  //     }),
  //     map(obj => new adminActions.BookingsByGender(obj))
  //   );
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/effects/admin.effect.ts